import { createSlice } from '@reduxjs/toolkit';

export const primaryFormSlice = createSlice({
    name: 'primaryForm',
    initialState: {
        value: {
            firstName: '',
            lastName: '',
            email: '',
        },
    },
    reducers: {
        setPrimaryForm: (state, action) => {
            const newValue = action.payload;
            state.value = { ...state.value, ...newValue };
        },
    },
});

// Action creators are generated for each case reducer function
export const { setPrimaryForm } = primaryFormSlice.actions;

export default primaryFormSlice.reducer;
